window.addEventListener("DOMContentLoaded", () => {
    gsap.registerPlugin(ScrollTrigger);

    // Designed to be different 
    gsap.from("#designed_to_be_different .never_dull_moment_main-heading", {
        opacity: 0,
        y: 30,
        scrollTrigger: {
            trigger: "#designed_to_be_different",
            start: "top 70%",
            end: "top 20%",
            scrub: true,
        },
    });

    // Watch Image with Content Section  
    gsap.from("#watch-img-with-content .watch_content_wrapper", {
        opacity: 0,
        y: 30,
        scrollTrigger: {
            trigger: "#watch-img-with-content",
            start: "top 70%",
            end: "top 20%",
            scrub: true,
        },
    });

    // Powered By HiSilicon Section
    gsap.from("#custom_img_with_text .custom_text_wrapper", {
        opacity: 0,
        y: 30,
        scrollTrigger: {
            trigger: "#custom_img_with_text .custom_text_wrapper",
            start: "top 70%",
            end: "top 20%",
            scrub: true,
        },
    });

    // Never a Dull Moment Section
    gsap.from("#never_dull_momemt .never_dull_moment_main-heading", {
        opacity: 0,
        y: 30,
        scrollTrigger: {
            trigger: "#never_dull_momemt",
            start: "top 70%",
            end: "top 30%",
            scrub: true,
        },
    });

    gsap.from("#never_dull_momemt .never_dull_moment_blocks", {
        opacity: 0,
        y: 30,
        scrollTrigger: {
            trigger: ".never_dull_moment_blocks",
            start: "top 70%",
            end: "top 30%",
            scrub: true,
        },
    });

    // Anarc Battery Section
    gsap.from("#anarc-battery-descp .anarc-battery-description-top-content-wrapper", {
        opacity: 0,
        y: 30,
        scrollTrigger: {
            trigger: "#anarc-battery-descp",
            start: "top 70%",
            end: "top 30%",
            scrub: true,
        },
    });
    gsap.from("#anarc-battery-descp .anarc-battery-description-bottom-content-wrapper", {
        opacity: 0,
        y: 30,
        scrollTrigger: {
            trigger: ".anarc-battery-description-bottom-content-wrapper",
            start: "center 90%",
            end: "center 50%",
            scrub: true,
        },
    });

    // For Mind, Body & Bold Moves Section
    gsap.from("#bold-moves .make-move-count-main-heading", {
        opacity: 0,
        y: 30,
        scrollTrigger: {
            trigger: "#bold-moves",
            start: "top 70%",
            end: "top 20%",
            scrub: true,
        },
    });

    // Anarc Banner Section
    gsap.from("#anarc-banner .bottom-content", {
        opacity: 0,
        y: 30,
        scrollTrigger: {
            trigger: "#anarc-banner .bottom-content",
            start: "top 70%",
            end: "top 20%",
            scrub: true,
        },
    });

    // Make Every Move Count Section   
    gsap.from("#make-every-move-count .make-move-count-main-heading", {
        opacity: 0,
        y: 30,
        scrollTrigger: {
            trigger: "#make-every-move-count",
            start: "top 70%",
            end: "top 30%",
            scrub: true,
        },
    });

    // Dynamic Analouge Section
    gsap.from("#dynamic-analogue .dynamic-analogue-content-wrapper", {
        opacity: 0,
        y: 30,
        scrollTrigger: {
            trigger: "#dynamic-analogue .dynamic-analogue-content-wrapper",
            start: "top 70%",
            end: "top 20%",
            scrub: true,
        },
    });

    // Mix Match and Make it Your's Section
    gsap.from("#mix-match-product-slider .mix-match-product_content_wrapper", {
        opacity: 0,
        y: 30,
        scrollTrigger: {
            trigger: ".mix-match-product_content_wrapper",
            start: "top 70%",
            end: "top 20%",
            scrub: true,
        },
    });

    // Stay Connected, Stay Hand free Section
    gsap.from("#stay-connected .anarc-stay-connected_content_wrapper", {
        opacity: 0,
        y: 30,
        scrollTrigger: {
            trigger: "#stay-connected",
            start: "top 70%",
            end: "top 20%",
            scrub: true,
        },
    });

    // In the Box Section
    gsap.from("#anarc-txt-with-img-icons .anarc_content_box_1", {
        opacity: 0,
        y: 30,
        scrollTrigger: {
            trigger: "#anarc-txt-with-img-icons .anarc_content_box_1",
            start: "top 70%",
            end: "top 20%",
            scrub: true,
        },
    });

    gsap.from("#anarc-txt-with-img-icons .anarc_content_box_2", {
        opacity: 0,
        y: 30,
        scrollTrigger: {
            trigger: "#anarc-txt-with-img-icons .anarc_content_box_2",
            start: "top 70%",
            end: "top 20%",
            scrub: true,
        },
    });
});